import './PageFraming.scss';
import { FC } from "react";

export const Header: FC = () => {

	return (
		<div className="header-container">
			<img src="https://sites.spondo.com/wp-content/uploads/2021/01/SSFF-Wide-Logo-For-Top-of-Landing-Page.jpg"
				 alt="Sunshine Short Film Festival 2021" />
		</div>
	);
}
